/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useEffect } from 'react';
import Navbar from 'react-bootstrap/Navbar';

import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';
import './PageLayout.css';
import '../App.css';
import { Link } from 'react-router-dom';
import Footer from './Footer';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {

    const { accounts } = useMsal();
    const account = accounts[0];
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => { document.title = isAuthenticated ? 'esvco' : ''; }, [isAuthenticated]);

    return (
        <>
            {isAuthenticated ? (
                <>
                    <Navbar bg="primary" variant="dark" className="navbarStyle">
                        <Link to="/">
                            <img
                                src="/esVolta_logo-small.jpg"
                                width="90"
                                height="35"
                                className="d-inline-block align-top"
                                alt="esVolta logo"
                            />
                        </Link>
                        <Navbar.Text>
                            <a href="/reports" className="reports-link">Reports</a>
                        </Navbar.Text>
                        <Navbar.Text>
                            <a href="/asset-info" className="reports-link">Asset Info</a>
                        </Navbar.Text>
                        <Navbar.Text>
                            <a href="/simulator" className="reports-link">Simulator</a>
                        </Navbar.Text>
                        <Navbar.Text>
                            <a href="/trading" className="reports-link">Trading</a>
                        </Navbar.Text>
                        <div className="collapse navbar-collapse justify-content-end">
                            <Navbar.Text className="navbar-right">
                                {account.name}
                            </Navbar.Text>
                            <SignOutButton />
                        </div>
                    </Navbar>
                    <div className="title">

                    </div>
                    <div className="profileContent">
                        {props.children}
                    </div>
                    <Footer />
                </>
            ) : (
                <Navbar bg="primary" variant="dark" className="navbarStyle">
                    <a className="navbar-brand" href="/">
                        Microsoft Identity Platform
                    </a>
                    <div className="collapse navbar-collapse justify-content-end">
                        <SignInButton />
                    </div>
                </Navbar>
            )}
        </>
    );
};
export default PageLayout;
